// 新建 src/utils/crypto.js

import CryptoJS from 'crypto-js/crypto-js'
import md5 from 'js-md5'
// KEY的取值 = md5('RIneDRFWrtXgXziHn3hH3lx6dD51CzxN' + ua).slice(0, 16)
var ua = navigator.userAgent
var str = md5('RIneDRFWrtXgXziHn3hH3lx6dD51CzxN' + ua).slice(0, 16)
const KEY = CryptoJS.enc.Utf8.parse(str)
// console.log(KEY, 'KEY')
// const KEY = CryptoJS.enc.Utf8.parse('R9jTW7taR3kg7X22') // 'retedfgd' 与后台一致
// const IV = CryptoJS.enc.Utf8.parse('asdqwe') // 'asdqwe' 与后台一致

// AES加密 ：字符串 key iv  返回base64

export function Encrypt(str, keyStr) {
  let key = KEY
  // let iv = IV

  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr)
    // iv = CryptoJS.enc.Utf8.parse(ivStr)
  }
  let srcs = CryptoJS.enc.Utf8.parse(str)
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    // iv: iv,
    // mode: CryptoJS.mode.ECB,
    mode: CryptoJS.mode.ECB, // mode 与后台一致
    padding: CryptoJS.pad.ZeroPadding
  })
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
}

// AES 解密 ：字符串 key iv  返回base64
export function Decrypt(str) {
  let key = KEY
  // let iv = IV

  // if (keyStr) {
  //   key = CryptoJS.enc.Utf8.parse(keyStr)
  //   // iv = CryptoJS.enc.Utf8.parse(ivStr)
  // }

  let base64 = CryptoJS.enc.Base64.parse(str)
  let src = CryptoJS.enc.Base64.stringify(base64)

  var decrypt = CryptoJS.AES.decrypt(src, key, {
    // iv: iv,
    // mode: CryptoJS.mode.ECB,
    mode: CryptoJS.mode.ECB, // 保持一致
    padding: CryptoJS.pad.ZeroPadding
  })

  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  return decryptedStr.toString()
}
